import { FC, useContext, useEffect } from "react";
import { Controller, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { Link } from "react-router-dom";

import FooterText from "../../components/footerText";
import HubInputField from "../../components/inputType";
import ContactAndSafetyInfo from "src/components/contactAndSafetyInfo";

import { TextAlignProps } from "src/components/contactAndSafetyInfo/types";
import useFetch from "../../hooks/useFetch";
import { ToastContext } from "../../context/toastContext";
import { forgotpasswordSchema } from "../../validation/forgotPassword";
import { APIEndpoints } from "../../types/apiTypes";
import { ToastTypes } from "../../types";
import { ForgotPasswordResponseType } from "./types";
import { LoaderContext } from "../../context/loaderContext";
import { LogoBanner } from "src/assets";





const HubForgotPassword: FC = (): JSX.Element => {
  const { control, handleSubmit, reset } = useForm({
    mode: 'all',
    resolver: yupResolver(forgotpasswordSchema),
  });
  const { showToast } = useContext(ToastContext);
  const { setLoader, hideLoader } = useContext(LoaderContext);





  const { loading, error, data, mutate, removeErrorAndData } = useFetch<null, null, ForgotPasswordResponseType>(APIEndpoints.USER_FORGOT_PASSWORD);

  useEffect(() => {
    if (data || error) {
      hideLoader();
      if (data) {
        const { message } = data;
        showToast([message], ToastTypes.SUCCESS);
        reset();
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, error]);

  const submitForm = async (values: { email: string }) => {
    setLoader();
    if ((error && error.length > 0) || data) removeErrorAndData();

    mutate({ user: values });
  };




  return (
      <div className="container-fluid login-sec d-flex flex-fill flex-column justify-content-between overflow-auto">
        <div className="container">
          <div className="row my-4 mb-0 mb-md-4">
            <div className="col-12 col-md-7">
              <img height="110px" className="img-fluid" src={LogoBanner} alt="Banner Info"/>
            </div>
            <div className="col-12 col-md-5 pt-2">
              <ContactAndSafetyInfo alignText={TextAlignProps.TEXT_END} textColor="black"/>
            </div>
          </div>
          <div className="login-hero" style={{minHeight:"350px"}}>
            <div className="row mb-3">
              <div className="col-12 col-md-7"></div>
              <div className="col-12 col-md-5">
                <form className="card" onSubmit={handleSubmit(submitForm)}>
                  <div className="card-header card-header-guest">
                    <h4 className="m-0 fw-bold">Forgot your password?</h4>
                  </div>
                  <div className="card-body">
                    <Controller
                        name="email"
                        control={control}
                        defaultValue=""
                        render={({field, fieldState: {error}}) => (
                            <HubInputField
                                inputId="email"
                                isRowBased={false}
                                isRequired={true}
                                field={field}
                                error={error}
                                inputLabel="Email"
                                inputType="email"
                            />
                        )}
                    />

                    <div className="">
                      <button disabled={loading} className="btn btn-primary" type="submit">
                        {loading ? (<i className="spinner-border me-2"></i>) : null}
                        Send me reset password instruction
                      </button>
                      <br/>
                      <Link to="/users/sign_in">Login</Link>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
          <FooterText/>
        </div>
      </div>
  );
};

export default HubForgotPassword;
